import $ from 'jquery'
import TableCellRenderer from '../../../../table/TableCellRenderer'
import TeamScopeCellContent from './TeamScopeCellContent'
import {canUserAccessManagerScopes} from '../../utils'
import {UserTeamAssignmentType} from '../../../../panels/user/constants'

class TeamScopeCellRenderer extends TableCellRenderer {
    constructor({
                    editable,
                    onClick = () => {},
                    onMouseIn = () => {},
                    onMouseOut = () => {},
                    isURAEnabled = false,
                    isBTYEnabled = false,
                }) {

        super()

        this.params = {
            editable,
            onClick,
            onMouseIn,
            onMouseOut,
            isURAEnabled,
            isBTYEnabled,
        }

    }

    generateContent(cell) {
        this.content = new TeamScopeCellContent()
        this.content.init($(cell.getCellEl()))
        this.updateContent(cell)
    }

    updateContent(cell) {
        const {
            teamAssignmentType,
            assignedUsersCount,
            hasManageUsersRight,
        } = cell.getValue()

        const hasManageScope = canUserAccessManagerScopes({
            userInfo: cell.getValue(),
            isURAEnabled: this.params.isURAEnabled,
            isBTYEnabled: this.params.isBTYEnabled
        })
        this.content.setState({
            assignedUsersCount,
            disabled: !hasManageScope,
            notAvailable: !this.params.editable,
            allScope: teamAssignmentType === UserTeamAssignmentType.ALL || hasManageUsersRight,
            noAccess: teamAssignmentType === UserTeamAssignmentType.NO,
        })

        $(cell.getCellEl())
            .on('click', (e) => this.params.onClick(cell, e))
            .hover(
                (e) => this.params.onMouseIn(cell, e),
                (e) => this.params.onMouseOut(cell, e)
            )
    }

    getCellClassName() {
        return ['teamScopeCell']
    }

    update({isURAEnabled, isBTYEnabled, hasManageScope}) {
        this.params.isURAEnabled = isURAEnabled
        this.params.isBTYEnabled = isBTYEnabled

        this.content.setState({disabled: !hasManageScope})
    }
}

export default TeamScopeCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/TeamScopeCellRenderer.js